import Swiper from '../../node_modules/swiper/js/swiper.js';
import css from '../../node_modules/swiper/css/swiper.css';

(function() {
	'use strict';

    var Carousel = ctme.Carousel = function () { },
		hero = document.getElementById('heroSwiper'),
        brands = document.getElementById('brandsSwiper'),
		mobileSwiper = document.getElementsByClassName('js-mobileSwiper'),
		myMobileSwiper,
		office = document.getElementById('officeSwiper'),
		people = document.getElementById('peopleSwiper'),
		restaurants = document.getElementById('restaurantsSwiper'),
		social = document.getElementById('social');

	Carousel.prototype.mobileCarousel = function() {

        var mobileSwipers = function() {

            var mySwiper = [],
                status = false,
		        ww = window.innerWidth,
		        action = function() {
		            ww = window.innerWidth;

		            if (ww <= 640 && status === false) {

		                for (var i = 0; i < mobileSwiper.length; i ++) {
                            mySwiper[i] = new Swiper (mobileSwiper[i], {
                    			loop: true,
                    			speed: 400,
                    			spaceBetween: 8,
                    			slidesPerView: 1,
                                centeredSlides: true,
                                swiperContainer: '.js-mobileSwiper',
                                navigation: {
                                    nextEl: '.swiper-next',
                                    prevEl: '.swiper-prev',
                                }
                    		});
                	    }

                        status = true;
        			}

        			if (ww > 640 && status === true) {

		                for (var j = 0; j < mobileSwiper.length; j ++) {
                            mySwiper[j].destroy(true, true);
                	    }

                        status = false;
        			}
		        };

			action();
			window.addEventListener('resize', action);
		};

		mobileSwipers();
	};

	Carousel.prototype.heroCarousel = function() {

        if (hero.getElementsByClassName('swiper-slide').length <= 1) {
            hero.classList.add('is-disabled')
        } else {

    		var mySwiper = new Swiper (hero, {
    			autoplay: {
    			    delay: 5000
                },
                loop: true,
    			speed: 500,
    			navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                }
    		});
        }
	};

    Carousel.prototype.brandsCarousel = function() {
        var mySwiper = new Swiper (brands, {
            autoplay: {
                delay: 5000
            },
            loop: true,
            speed: 500,
            navigation: {
                nextEl: '.c-brands .swiper-next',
                prevEl: '.c-brands .swiper-prev'
            }
        });
    };

    Carousel.prototype.officeCarousel = function() {
        var mySwiper = new Swiper (office, {
            autoplay: {
                delay: 5000
            },
            breakpoints: {
                591: {
                    slidesPerView: 2,
                },
                890: {
                    slidesPerView: 3,
                }
            },
            loop: true,
            slidesPerView: 1,
            speed: 500,
            navigation: {
                nextEl: '.c-office .swiper-next',
                prevEl: '.c-office .swiper-prev'
            }
        });
    };

    Carousel.prototype.peopleCarousel = function() {
        var mySwiper = new Swiper (people, {
            autoplay: {
                delay: 5000
            },
            slidesPerView: 1,
            speed: 500,
            navigation: {
                nextEl: '.c-people .swiper-next',
                prevEl: '.c-people .swiper-prev'
            }
        });
    };

    Carousel.prototype.restaurantsCarousel = function() {
        var mySwiper = new Swiper (restaurants, {
            autoplay: {
                delay: 5000
            },
            breakpoints: {
                591: {
                    slidesPerView: 2,
                },
                640: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                }
            },
            loop: true,
            slidesPerView: 1,
            speed: 500,
            navigation: {
                nextEl: '.c-restaurants .swiper-next',
                prevEl: '.c-restaurants .swiper-prev'
            }
        });
    };

	Carousel.prototype.social = function() {

		var mySwiper = new Swiper (social, {
    		freeMode: true,
    		mousewheel: true,
			scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true
            },
            speed: 600,
		});
	};

	ctme.Carousel = new Carousel();



}(window.ctme = window.ctme || {}));



